/*
Create booking
*/
import {windowRepairImage} from "../../constants/global";

export async function postImage(booking:Booking) {
    console.log('post-image.ts')
    const reactAppData = window.react_data.api_url ? window.react_data : {api_url:''};
    if(process.env.NODE_ENV === 'development') {
       return {'status':'ok'}
    } else {
        let data = new FormData();
        data.append('action', 'react_data');
        data.append('call', 'save image');
        data.append('image', windowRepairImage.image);
        data.append('session', booking.session.toString());
        return await fetch(reactAppData.api_url, {body:data, method:'post'})
            .then(res => res.json())
            .then(
                (result) => {
                    return result
                },
                (error) => {
                    return {error:error}
                }
            );
    }
}
